import { render, staticRenderFns } from "./scanning.vue?vue&type=template&id=2c5165fa&scoped=true"
import script from "./scanning.vue?vue&type=script&lang=js"
export * from "./scanning.vue?vue&type=script&lang=js"
import style0 from "./scanning.vue?vue&type=style&index=0&id=2c5165fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5165fa",
  null
  
)

export default component.exports